import { PropsWithChildren } from "react";
import styles from "./button.module.css";

interface ComponentProp extends PropsWithChildren {
  variant: string;
  width?: string;
  onClick?: () => void;
  underline?: boolean;
  color?: string;
  fontSize?: string;
  type?: "submit" | "reset" | "button" | undefined;
  disabled?: boolean;
}

const CustomButton: React.FC<ComponentProp> = ({
  children,
  variant,
  onClick,
  underline,
  color,
  width,
  fontSize,
  type,
  disabled,
}) => {
  const buttonVariants = [
    "solid",
    "primary",
    "ghost",
    "outline",
    "transparent",
    "naked",
    "default",
    "red",
  ];

  return (
    <>
      {variant === buttonVariants[0] && (
        <button
          className={styles.solid}
          onClick={onClick}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          type={type}
          disabled={disabled}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[1] && (
        <button
          className={styles.primary}
          onClick={onClick}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          disabled={disabled}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[2] && (
        <button className={styles.ghost} onClick={onClick} disabled={disabled}>
          {children}
        </button>
      )}

      {variant === buttonVariants[3] && (
        <button
          className={styles.outline}
          onClick={onClick}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          disabled={disabled}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[4] && (
        <button
          className={styles.transparent}
          onClick={onClick}
          disabled={disabled}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[5] && (
        <button
          className={styles.naked}
          style={{
            textDecoration: underline ? "underline" : "none",
            color: color ? color : "#5BC065",
          }}
          onClick={onClick}
          disabled={disabled}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[6] && (
        <button
          className={styles.default}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          disabled={disabled}
          onClick={onClick}
          type={type}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[7] && (
        <button
          className={styles.red}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          disabled={disabled}
          onClick={onClick}
        >
          {children}
        </button>
      )}

      {/* {(variant === buttonVariants[5]) && <button className={styles.naked} style={{textDecoration : underline ? "underline" : "none", color: color ? color: "#5BC065"}} onClick={onClick}>{text}</button>} */}
    </>
  );
};

export default CustomButton;
